import { render, staticRenderFns } from "./ImageUploadResizer.vue?vue&type=template&id=3e3d3012&"
import script from "./ImageUploadResizer.vue?vue&type=script&lang=js&"
export * from "./ImageUploadResizer.vue?vue&type=script&lang=js&"
import style0 from "./ImageUploadResizer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports